const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.556396484375,
    height: 15.556396484375,
    viewBox: "0 0 15.556396484375 15.556396484375",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    opacity: 1,
    d: "M9.31025e-05 1.41421L14.1422 15.5563L15.5564 14.1421L1.41431 0L9.31025e-05 1.41421Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    opacity: 1,
    d: "M14.1422 -2.89679e-05L4.76837e-05 14.1421L1.41426 15.5563L15.5564 1.41418L14.1422 -2.89679e-05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.047a19f269479c8c9ea83d9cd3ac4c5d.svg";
export { ForwardRef as ReactComponent };